const initialized = new WeakSet();

export default function init(element) {
    const doc = element.ownerDocument;
    if (initialized.has(element)) {
        return;
    }

    initialized.add(element);

    (function () {
        const EXCLUSIVE_ROLE_ERCS = new Set(['ECOM_ACC_01', 'ECOM_ACC_02', 'ECOM_ACC_03', 'ECOM_ACC_04']);
        function getExclusiveCheckboxes() {
            return Array.from(doc.querySelectorAll('tr[data-selectable="true"]'))
                .filter(row => {
                    const marker = row.querySelector('[data-account-role-erc]');

                    return marker !== null && EXCLUSIVE_ROLE_ERCS.has(marker.dataset.accountRoleErc);
                })
                .map(row => row.querySelector('input[type="checkbox"][name$="_rowIds"]'))
                .filter(Boolean);
        }

        function updateExclusiveState() {
            const checkboxes = getExclusiveCheckboxes();

            const selected = checkboxes.find(cb => cb.checked);

            if (!selected) {
                checkboxes.forEach(cb => (cb.disabled = false));
                return;
            }

            checkboxes.forEach(cb => {
                cb.disabled = cb !== selected;
            });
        }

        doc.addEventListener('change', function (event) {
            const cb = event.target;

            const exclusiveCheckboxes = getExclusiveCheckboxes();

            if (!exclusiveCheckboxes.includes(cb)) {
                return;
            }

            if (cb.checked) {
                exclusiveCheckboxes.forEach(other => {
                    if (other !== cb) {
                        other.checked = false;
                        other.disabled = true;
                    }
                });
            } else {
                exclusiveCheckboxes.forEach(other => {
                    other.disabled = false;
                });
            }
        });

        updateExclusiveState();
    })();

    // Register component events on element, rather than document.
    (function () {
        const sendHeaderTitle = () => {
            const headerTextEl = doc.querySelector('.permission-monitor-header .sheet-text');
            if (!headerTextEl) {
                return;
            }

            const titleText = headerTextEl.textContent?.trim();
            if (!titleText) {
                return;
            }

            window.dispatchEvent(
                new CustomEvent('amsOsramPermissionMonitorAssignRolesTitle', {
                    detail: {
                        titleText,
                    },
                })
            );
        };

        if (doc.readyState === 'complete' || doc.readyState === 'interactive') {
            sendHeaderTitle();
        } else {
            doc.addEventListener('DOMContentLoaded', sendHeaderTitle);
        }
    })();
}
